import { render, staticRenderFns } from "./DangerousGoodSdsImportDialog.vue?vue&type=template&id=6721b99a&scoped=true"
import script from "./DangerousGoodSdsImportDialog.vue?vue&type=script&lang=js"
export * from "./DangerousGoodSdsImportDialog.vue?vue&type=script&lang=js"
import style0 from "./DangerousGoodSdsImportDialog.vue?vue&type=style&index=0&id=6721b99a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6721b99a",
  null
  
)

export default component.exports